import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const AncillaryOverridesLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: OverridesLayout } = await import(
    "@workflows/ancillaries/overrides/overrides-layout/OverridesLayout"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_OVERRIDES}>
      <OverridesLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryOverridesLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryOverrides } = await import("@workflows/ancillaries/overrides");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_OVERRIDES}>
      <AncillaryOverrides />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryOverridesCreateLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: OverrideCreateAndEditPanel } = await import(
    "@workflows/ancillaries/overrides/overrides-panels/OverrideCreateAndEditPanel"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_OVERRIDES}>
      <OverrideCreateAndEditPanel type="create" />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
export const AncillaryOverridesEditLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: OverrideCreateAndEditPanel } = await import(
    "@workflows/ancillaries/overrides/overrides-panels/OverrideCreateAndEditPanel"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_OVERRIDES}>
      <OverrideCreateAndEditPanel type="edit" />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};

export const AncillaryOverridesDuplicateLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: OverrideCreateAndEditPanel } = await import(
    "@workflows/ancillaries/overrides/overrides-panels/OverrideCreateAndEditPanel"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_OVERRIDES}>
      <OverrideCreateAndEditPanel type="duplicate" />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
